/**
 * Handle benefits page javascript behavior
 */

window.app = window.app || {};

(function (benefitsManager, $) {

    /**
     * Initializes the behavior.
     */
    benefitsManager.init = function () {
        _handleEvents();
    };

    /**
     * Handle events
     */
    var _handleEvents = function () {
        $('.benefit-group-title').on('click', function() {

            if ($(window).width() < 768) {
                var _parent = $(this).parent('.benefit-group');

                if (!_parent.hasClass('open')) {
                    _parent
                        .addClass('open')
                        .find('.benefit-group-items')
                        .slideDown();
                } else {
                    _parent
                        .removeClass('open')
                        .find('.benefit-group-items')
                        .slideUp();
                }
            }
        });
    };
})(
    window.app.benefitsManager = window.app.benefitsManager || {},
    jQuery
);
